var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, createRef } from 'react';
import { DivTag } from '../../Utils/AtomicTag';
import * as PropTypes from 'prop-types';
import { BaseTable } from './BaseTable';
var HeadTable = /** @class */ (function (_super) {
    __extends(HeadTable, _super);
    function HeadTable(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperRef = createRef();
        _this.state = {
            hideXScroll: '',
        };
        return _this;
    }
    HeadTable.prototype.componentDidMount = function () {
        var _a;
        var table = this.context.table;
        var scroll = table.props.scroll;
        // 当头部出现水平滚动条时，要隐藏
        if (scroll.x && scroll.x > ((_a = this.wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) {
            this.setState({
                hideXScroll: ' hide-x-scroll',
            });
        }
    };
    HeadTable.prototype.render = function () {
        var _a = this.props, columns = _a.columns, data = _a.data, fixed = _a.fixed, handleBodyScrollLeft = _a.handleBodyScrollLeft;
        var hideXScroll = this.state.hideXScroll;
        var table = this.context.table;
        var saveRef = table.saveRef, columnManager = table.columnManager;
        var hasRightFixed = columnManager.isAnyColumnsRightFixed();
        var _b = table.props, useFixedHeader = _b.useFixedHeader, scroll = _b.scroll;
        var wrapperClassName = '';
        if (scroll.y) {
            useFixedHeader = true;
            // 当有右固定时，设置头部表格容器的 overflowY 为 scroll，保证水平滚动时 head 和 body 中的每列对齐
            if (hasRightFixed) {
                wrapperClassName += 'y-scroll';
            }
        }
        if (!useFixedHeader) {
            return null;
        }
        return (React.createElement(DivTag, { className: "" + wrapperClassName + hideXScroll, ref: this.wrapperRef, autoPrefixedClassName: "head-table-wrapper" },
            React.createElement(DivTag, { autoPrefixedClassName: "head-table-box", onScroll: handleBodyScrollLeft, ref: fixed ? null : saveRef('headTable') },
                React.createElement(BaseTable, { columns: columns, hasHead: true, hasBody: false, fixed: fixed, data: data }))));
    };
    HeadTable.contextTypes = {
        table: PropTypes.any,
    };
    return HeadTable;
}(Component));
export { HeadTable };
